import iconNavbar from './icon-navbar.vue'

export default {
    iconNavbar
}